// Tenantra Inc. - Tiny 12-month trend line for a KPI tile
import { Line, LineChart, ResponsiveContainer, Tooltip, YAxis } from 'recharts';

export function Sparkline({ labels = [], values = [], format = (v) => v, color = '#0f766e', testId }) {
  const data = labels.map((l, i) => ({ l, v: values[i] }));
  if (data.filter(d => d.v != null).length < 2) return <div className="h-8" data-testid={testId} />;
  return (
    <div className="h-8 w-full" data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 2, bottom: 2, left: 2 }}>
          <YAxis hide domain={['dataMin', 'dataMax']} />
          <Tooltip cursor={false} contentStyle={{ fontSize: 11, borderRadius: 6, border: 'none', boxShadow: '0 4px 14px rgba(15,23,42,0.10)', padding: '4px 8px' }}
            labelFormatter={(_, p) => p?.[0]?.payload?.l} formatter={(v) => [format(v), '']} separator="" />
          <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.6} dot={false} connectNulls isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
